/**
 * Auth SDK singleton — wraps @nestmold/web-auth-center BrowserAuthClient
 */

import { BrowserAuthClient } from '@nestmold/web-auth-center/browser';
import type { TokenSession } from '@nestmold/web-auth-center/types';

const PLATFORM_CODE = import.meta.env.VITE_PLATFORM_CODE || 'user-center';

const client = new BrowserAuthClient({
  issuer: '',  // relative paths via vite proxy
  clientId: 'user-center-frontend',
  redirectUri: window.location.origin + '/oauth-callback',
  scope: 'openid profile email',
  platformCode: PLATFORM_CODE,
});

export { client };
export type { TokenSession };
